import { render, staticRenderFns } from "./AiStartupsModal.vue?vue&type=template&id=4a97f4a0&scoped=true&"
import script from "./AiStartupsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiStartupsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97f4a0",
  null
  
)

export default component.exports